import React from 'react';
import { Line } from 'rc-progress';

import Box from '@mui/material/Box';

import QTip from 'components/QuickenControls/QTip';

interface TxnPageFooterProps {
  hideSearch: boolean;
  hideFooter: boolean;
  footerRef: (elem: HTMLDivElement) => void;
  classes: Record<string, any>;
  transactionListMetrics: Record<string, any>;
  theme: Record<string, any>,
}

const TxnPageFooter: React.FC<TxnPageFooterProps> = (props) => {
  const { theme } = props;

  const metrics = props.transactionListMetrics;
  const txnReviewedPercentage = ((metrics.reviewedCount + 1) / (metrics.numTxns + 1)) * 100;
  let gradeText;
  let strokeColor;

  switch (true) {
    case txnReviewedPercentage < 25:
      gradeText = 'You have some work to do';
      strokeColor = theme.palette.personalDark;
      break;

    case txnReviewedPercentage < 50:
      gradeText = 'You are making good progress';
      strokeColor = theme.palette.caringDark;
      break;

    case txnReviewedPercentage < 75:
      gradeText = 'Over halfway there, keep reviewing!';
      strokeColor = theme.palette.optimisticDark;
      break;

    case txnReviewedPercentage < 100:
      gradeText = 'Just about reviewed them all, bring it home!';
      strokeColor = theme.palette.positiveLight;
      break;

    case txnReviewedPercentage >= 100:
      gradeText = 'All transactions reviewed, great work!';
      strokeColor = theme.palette.positiveDark;
      break;

    default:
      gradeText = 'Error';
      strokeColor = theme.palette.groundedDark;
  }

  if (props.hideFooter) {
    return (
      <Box
        height={2}
        overflow="hidden"
        ref={props.footerRef}
      />
    );
  }

  return (
    <div className={props.classes.txFooter} ref={props.footerRef}>
      {!props.hideSearch && metrics.numTxns > 0 && (
        <QTip
          title={`Transactions marked reviewed, (${metrics.reviewedCount}/${metrics.numTxns}) ${gradeText}`}
        >
          <Line
            className={props.classes.progressBar}
            percent={txnReviewedPercentage}
            strokeWidth={2}
            trailWidth={2}
            strokeColor={strokeColor}
          />
        </QTip>
      )}
    </div>
  );
};

export default TxnPageFooter;
